import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "mt-2 flex h-9 w-full rounded-md border-2 border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:mr-4 file:rounded-sm file:border-none file:bg-background file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-gray-100 file:text-gray-1100 file:duration-200 placeholder:!text-[hsla(var(--muted),0.42)] hover:file:cursor-pointer hover:file:bg-backgroundAccent focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-brand-primary disabled:select-text disabled:bg-background disabled:opacity-50 dark:border-backgroundAccent dark:placeholder:!text-[hsla(var(--muted),0.34)] md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
